/** Must match AuthProvider `authName` in App.tsx (react-auth-kit uses `{authName}_state` for user JSON). */
export const AUTHKIT_AUTH_NAME = "arno-app";
export const AUTHKIT_STATE_KEY = `${AUTHKIT_AUTH_NAME}_state`;
